import { s as stripe } from "../../../../../../chunks/stripe.js";
import { json } from "@sveltejs/kit";
import { g as generateLicenseAndNotifyUser } from "../../../../../../chunks/license.js";
import { g as get, L as LicenseCollection } from "../../../../../../chunks/firebase.js";
const ensureLicenses = async (starting_after) => {
  const checkouts = await stripe.checkout.sessions.list({
    starting_after,
    status: "complete",
    limit: 100
  });
  for await (const checkout of checkouts.data) {
    if (checkout.payment_status === "paid" && checkout.customer_details) {
      const license = await get(
        LicenseCollection(),
        checkout.customer_details.email
      );
      if (!license.data) {
        const paymentIntent = await stripe.paymentIntents.retrieve(
          checkout.payment_intent
        );
        await generateLicenseAndNotifyUser(
          paymentIntent,
          "We've recently upgraded our licensing infrastructure. Since you've already purchased a premium license, we've issued you a key to use on any device."
        );
      }
    }
  }
  if (checkouts.has_more) {
    await ensureLicenses(checkouts.data.pop()?.id);
  }
};
const GET = async () => {
  await ensureLicenses();
  return json({
    success: true
  });
};
export {
  GET
};
